<template>
  <div class="pay flex_column" v-if="orderDetail">
    <p class="order_num">{{orderDetail.detail}}</p>
    <div class="price">
      <p>￥</p>
      <p>{{orderDetail.totalFee/100}}</p>
    </div>
    <div class="merchant flex_row">
      <p>收款方</p>
      <p>{{orderDetail.mchName}}</p>
    </div>
    <div class="button" @click="toPay">立即支付</div>
    <div class="tips">支付安全由中国人民财产保险股份有限公司</div>
    <!-- 模态框 -->
    <div class="mask" v-if="maskShow">
      <!-- <div class="bg_filter"></div> -->
      <div class="mask_view flex_row">{{message}}</div>
    </div>
  </div>
</template>
<script>
import VConsole from 'VConsole';
import { getOpenId, getOrderDetail, booking, weixinConfig } from '../api/index.js';
export default {
  data() {
    return {
      orderDetail: '',
      configDetail: '',
      openid: '',
      payDetail: '',
      orderNo: '',
      payFlag: true,
      maskShow: false,
      message: ''
    }
  },
  methods: {

    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = window.location.href.split('#')[0]
      let search = url.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    },
    // 获取openId
    getOpenId() {
      let param = {
        code: this.code
      }
      getOpenId(param).then(res => {
        this.openid = res.data.openid;
        this.toPay()
      })
    },
    // 获取订单详情
    getOrderDetail() {
      const that = this;
      let param = {
        orderNo: this.orderNo
      }
      getOrderDetail(param).then(res => {
        if (res.data.resultStatus || true) {
          that.orderDetail = res.data.resultData;
        }
      })
    },

    // 获取微信配置
    getConfig() {
      let param = {
        url: window.location.href
      }
      weixinConfig(param).then(res => {
        this.configDetail = res.data;
      })
    },
    // 掉下单接口
    book() {
      let param = {
        orderNo: this.orderDetail.orderNo,
        openid: this.openid
      }
      booking(param).then(res => {
        if (res.data.return_code == 'SUCCESS') {
          this.payDetail = JSON.parse(res.data.prepay_url);
          this.initwx();
        } else {
          this.maskShow = true;
          this.message = res.data.return_msg;
          setTimeout(() => {
            this.maskShow = false;
          }, 2000)
        }

      })
    },
    // 初始化微信api
    initwx() {

      const that = this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.configDetail.appId, // 必填，公众号的唯一标识
        timestamp: this.configDetail.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.configDetail.nonceStr, // 必填，生成签名的随机串
        signature: this.configDetail.signature,// 必填，签名
        jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
      });
      wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        wx.chooseWXPay({
          timestamp: that.payDetail.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: that.payDetail.nonceStr, // 支付签名随机串，不长于 32 位
          package: that.payDetail.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: that.payDetail.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: that.payDetail.paySign, // 支付签名
          success: function (res) {
            // 支付成功后的回调函数 跳转returl_url
            if (that.orderDetail.returnUrl) {
              window.location.replace(that.orderDetail.returnUrl)
            } else {
              wx.closeWindow();
            }

          }
        });
      });
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.log(res, '验证失败')
      });
    },
    async toPay() {
      await this.getConfig();
      await this.book();
    },
    async initData() {
      await this.getOrderDetail();
      await this.getOpenId();
    },
    goBack () {
      wx.closeWindow();
    }
  },
  created() {
    // var vConsole = new VConsole();
    let code = this.getUrlParam('code');
    let orderNo = this.getUrlParam('state');
    this.code = code;
    this.orderNo = orderNo;
    this.initData()
  }
}
</script>
<style lang="scss" scoped>
.flex_row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex_column {
  display: flex;
  flex-direction: column;
}
p {
  margin: 0px;
}
.pay {
  width: 100%;
  height: 100%;
  background: #f4f5f8;
  align-items: center;
  .order_num {
    font-size: 30px;
    color: #111111;
    margin-top: 40px;
    font-weight: bold;
  }
  .price {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    p:nth-child(1) {
      font-size: 50px;
      color: #111111;
      font-weight: bold;
    }
    p:nth-child(2) {
      font-size: 70px;
      color: #111111;
      font-weight: bold;
    }
  }

  .merchant {
    width: 100%;
    height: 90px;
    background: #fff;
    justify-content: space-between;
    padding: 0 40px;
    box-sizing: border-box;
    line-height: 90px;
    margin-top: 25px;
    border-top: 1px solid #dadada;
    border-bottom: 1px solid #dadada;
    p:nth-child(1) {
      font-size: 30px;
      color: #787878;
    }
    p:nth-child(2) {
      font-size: 30px;
      color: #111111;
    }
  }

  .button {
    width: 95%;
    height: 88px;
    position: relative;
    background: #04c161;
    text-align: center;
    line-height: 88px;
    font-size: 32px;
    color: #fff;
    margin-top: 61px;
    text-decoration: none;
    outline: 0 !important;
    user-select: none;
    border-radius: 10px;
  }
  .button:active {
    background: #06ad56;
  }
  .tips {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: 20px;
    color: #ccc;
  }
  .mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    .mask_view {
      width: 400px;
      position: absolute;
      padding: 30px;
      box-sizing: border-box;
      // background: hsla(0, 0%, 100%, 0.25) border-box;
      background: #fff;
      box-shadow: 0 0 0 1px hsla(0, 0%, 100%, 0.3) inset,
        0 0.5em 1em rgba(0, 0, 0, 0.6);
      top: 45%;
      left: 50%;
      height: 265px;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      justify-content: center;
      font-size: 32px;
      text-align: center;
    }
    .mask_view::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      -webkit-filter: blur(20px);
      filter: blur(20px);
    }
    .bg_filter {
      filter: blur(10px);
      width: 400px;
      position: absolute;
      top: 45%;
      background: #fff;
      left: 50%;
      height: 265px;
      transform: translate(-50%, -50%);
      border-radius: 10px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/page/pay.vue